import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./style.css";
import Navigation from "../../components/Navigation";
// import Footer from "../../components/Footer";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="notfound-container">
      <Navigation />
      <div className="notfound-content">
        <h1 className="notfound-title">404</h1>
        <p className="notfound-text">Oops! Page not found. The page either doesn't exist or still under construction</p>
        <a href="/" className="notfound-link">
          Return to Home
        </a>
      </div>
      {/* <Footer /> */}
    </div>
  );
};

export default NotFound;
